import * as R from 'ramda'

import * as actionTypes from 'store/actionTypes/menuSearch'

const initialState = { query: '' }

export default (prevState, action) => {
  if (typeof prevState === 'undefined') return initialState

  const mergeState = R.mergeRight(prevState)

  switch (action.type) {
    case actionTypes.SET_MENU_SEARCH_QUERY:
      return mergeState({ query: action.query })
    default:
      return prevState
  }
}
